import React, { useState, useEffect } from 'react';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import produtoService from '../services/produtoService';
import PageHeader from './PageHeader';
import SkeletonLoader from './SkeletonLoader';
import EmptyState from './EmptyState';
import './../pages/Dashboard.css';

const ProdutosManager = () => {
  const initialFormState = { nome: '', descricao: '', preco: '', estoque: 0 };
  const [produtos, setProdutos] = useState([]);
  const [formState, setFormState] = useState(initialFormState);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true); // Adiciona o estado de loading

  const fetchProdutos = async () => {
    setLoading(true);
    try {
      const data = await produtoService.getProdutos();
      setProdutos(data);
    } catch (error) {
      console.error("Erro ao buscar produtos", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProdutos();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editingId) {
      await produtoService.updateProduto(editingId, formState);
    } else {
      await produtoService.createProduto(formState);
    }
    fetchProdutos();
    resetForm();
  };

  const handleEdit = (produto) => {
    setEditingId(produto.id);
    setFormState({
      nome: produto.nome,
      descricao: produto.descricao || '',
      preco: produto.preco,
      estoque: produto.estoque
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Tem certeza que deseja deletar este produto?")) {
      await produtoService.deleteProduto(id);
      fetchProdutos();
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setFormState(initialFormState);
  };

  return (
    <div className="page-container">
      <PageHeader title="Meus Produtos" />

      <div className="content-area">
        <div className="card">
          <h3>{editingId ? 'Editar Produto' : 'Adicionar Novo Produto'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="nome">Nome do Produto</label>
              <input id="nome" name="nome" className="form-input" value={formState.nome} onChange={handleInputChange} placeholder="ex: Pomada Modeladora" required />
            </div>
            <div className="form-group">
              <label htmlFor="preco">Preço de Venda (R$)</label>
              <input id="preco" name="preco" type="number" step="0.01" className="form-input" value={formState.preco} onChange={handleInputChange} placeholder="ex: 50.00" required />
            </div>
            <div className="form-group">
              <label htmlFor="estoque">Quantidade em Estoque</label>
              <input id="estoque" name="estoque" type="number" className="form-input" value={formState.estoque} onChange={handleInputChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="descricao_produto">Descrição (opcional)</label>
              <textarea id="descricao_produto" name="descricao" className="form-input" value={formState.descricao} onChange={handleInputChange}></textarea>
            </div>
            <div className="form-buttons">
              <button type="submit" className="btn btn-primary">
                {editingId ? 'Salvar Alterações' : 'Adicionar Produto'}
              </button>
              {editingId && <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancelar</button>}
            </div>
          </form>
        </div>

        <div className="card">
          <h3>Produtos Cadastrados</h3>
          {loading ? (
            <div>
              <SkeletonLoader />
              <SkeletonLoader />
              <SkeletonLoader />
            </div>
          ) : produtos.length > 0 ? (
            <ul className="service-list">
              {produtos.map(produto => (
                <li key={produto.id}>
                  <div className="service-info">
                    <strong>{produto.nome}</strong> - <span>R$ {produto.preco}</span>
                    <p>Estoque: {produto.estoque} unidades</p>
                  </div>
                  <div className="service-actions">
                    <button className="btn-icon" onClick={() => handleEdit(produto)}><FaPencilAlt /></button>
                    <button className="btn-icon btn-danger-icon" onClick={() => handleDelete(produto.id)}><FaTrash /></button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState
              message="Você ainda não cadastrou nenhum produto."
              actionText="Adicionar primeiro produto"
              onActionClick={() => document.querySelector('#nome')?.focus()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProdutosManager;